module.exports = __webpack_public_path__ + "img/biberkopf.463dd052.jpg";